import TerminalDetail from './TerminalDetail.vue';
import TerminalOverview from './detail/TerminalOverview.vue';
import TerminalConfiguration from './detail/TerminalConfiguration.vue';
import TerminalMetrics from './detail/TerminalMetrics.vue';
import TerminalJson from './detail/TerminalJson.vue';
import TerminalUsageHistory from './detail/TerminalUsageHistory.vue';

export default function RemoteRoutes() {
  return [
    {
      path: ':id',
      component: TerminalDetail,
      children: [
        {
          path: 'overview',
          component: TerminalOverview,
          name: 'terminalOverview'
        },
        {
          path: 'configuration',
          component: TerminalConfiguration,
          name: 'terminalConfiguration'
        },
        {
          path: 'usage',
          component: TerminalUsageHistory,
          name: 'terminalUsage'
        },
        {
          path: 'metrics',
          component: TerminalMetrics,
          name: 'terminalMetrics'
        },
        {
          path: 'json',
          component: TerminalJson,
          name: 'terminalJson'
        }
      ]
    }
  ]
}
